import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Page = ({ pageContext }) => (<div>
  <Layout title={`${pageContext.event.tournament}`}>
    <SEO title={`${pageContext.event.tournament} Result`}/>
    <h2>{pageContext.event.name}</h2>
    <table>
      <thead>
      <tr>
        <th>Rank</th>
        <th>Name</th>
      </tr>
      </thead>
      <tbody>
      {pageContext.event.standingsByEventIdList.map((standing, key) => (
        <tr key={key}>
          <td>{standing.placement}</td>
          <td>
            <Link to={`/players/${standing.playerByPlayerId.id}`}>
              {standing.playerByPlayerId.name}
            </Link>
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  </Layout>
</div>)

export default Page
